"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusTradeHub = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const CardRequirements_1 = require("../CardRequirements");
class VenusTradeHub extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VENUS_TRADE_HUB,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.SPACE],
            cost: 12,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.VENUS, 2)),
            metadata: {
                cardNumber: 'P90',
                description: 'Requires 2 Venus tags.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect('When you trade, gain 3 M€.', (eb) => {
                        eb.trade().startEffect.megacredits(3);
                    });
                }),
                victoryPoints: 1,
            },
        });
    }
    play() {
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.VenusTradeHub = VenusTradeHub;
//# sourceMappingURL=VenusTradeHub.js.map